import { deserialize } from "./deserialize"

export const deserializeJsonApi = (value: unknown): unknown => {
  try {
    return deserialize(value)
  } catch {
    return value
  }
}
